<template>
  <div class="md:py-0 lg:py-0 py-4 relative">
    <img
      src="@/assets/images/line/Vector 28.png"
      alt="lineimg"
      class="m-auto h-400px"
    />
    <div class="absolute bg-design-mbr-dots mob-hidden">
      <img
        src="../../../assets/images/caregiver/mbr-dots.svg"
        alt="bg-polygon"
        class=""
      />
    </div>
    <div class="absolute bg-design-mbr-ell mob-hidden">
      <img
        src="../../../assets/images/caregiver/mbr ell.svg"
        alt="bg-polygon"
        class="h-full"
      />
    </div>
    <div class="absolute bg-design-mbr-ell2 mob-hidden">
      <img
        src="../../../assets/images/caregiver/mbr ell.svg"
        alt="bg-polygon"
        class="h-full"
      />
    </div>
    <div class="absolute bg-design-mbr-poly mob-hidden">
      <img
        src="../../../assets/images/caregiver/mbr-poly.svg"
        alt="bg-polygon"
        class="h-full"
      />
    </div>
    <div class="lg:flex md:flex justify-center lg:ml-8 md:ml-8 ml-6 m-auto">
      <div
        class="borderprimary bg-white lg:p-4 md:p-4 mob-pt-3 absolute lg:top-28 md:top-28 top-8 rounded-2xl lg:w-auto md:w-auto w-9/12 m-auto"
      >
        <div class="bgcceff2 rounded-2xl">
          <div class="lg:flex md:flex items-center lg:p-6 md:p-6 p-4">
            <p class="font-semibold text-black fsize20 sm-fsize13">
              Your are not alone.
            </p>
            <div
              class="md:pl-12 lg:pl-14 pl-0 items-center flex lg:mx-auto md:mx-auto mob-justify-center"
            >
              <!-- <a
                href="https://forms.office.com/r/2U8V2SiQWp"
                target="_blank"
                class="acharhover-s"
              > -->
              <base-button
                @click="
                  handleRoute('request-form', 'share-your-story-expertise')
                "
                type="primary"
                class="py-2 whitespacenowrap px-8 text-base font-bold border-2 mt-2 md:mt-0 lg:mt-0 mx-auto md:w-auto lg:w-auto w-full"
                >Share your story with us</base-button
              >
              <!-- </a> -->
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {};
  },
  methods: {
    handlecommunity() {
      this.$router.push({ name: "community" });
    },
    handleRoute(name, route) {
      this.$router.push({
        name: name,
        params: {
          pathName: route,
        },
      });
    },
  },
};
</script>
<style>
@media (min-width: 641px) {
  .h-400px {
    height: 400px;
  }
}
</style>
